module.exports = __webpack_public_path__ + "static/media/cv.46eab866.pdf";